export default __webpack_public_path__ + "static/media/ByDomainBg.0b0aba74.svg";